import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  @Input() customPositonClass: string = 'wrap'; 
  @Input() loadingMessage: string = 'Loading'

  getCustomPostionClass(){
    return this.customPositonClass;
  }

  getLoadingMessage(){
    return this.loadingMessage;
  }

}
